import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface PatientSummaryStore {
    patientSummaryData : any,
    setPatientSummaryData : (x:any) => void,
    diagnosisCodeData : any,
    setDiagnosisCodeData : (x:any) => void,
    providerSummaryData : any,
    setProviderSummaryData : (x:any) => void,
    providerSearchText: any, 
    setProviderSearchText: (x:any) => void,
    patientSearchText: any, 
    setPatientSearchText: (x:any) => void,
    clearStore: () => void
}

let  store: StateCreator<PatientSummaryStore, [], [], PatientSummaryStore> | StoreApi<PatientSummaryStore> = (set: SetState<PatientSummaryStore>) => ({
    patientSummaryData: {},
    setPatientSummaryData: (x) => {
    set(() => ({ patientSummaryData : x }))
    },
    diagnosisCodeData: [],
    setDiagnosisCodeData: (x) => {
    set(() => ({ diagnosisCodeData : x }))
    },
    providerSummaryData: [],
    setProviderSummaryData: (x) => {
    set(() => ({ providerSummaryData : x }))
    },
    providerSearchText: {},
    setProviderSearchText: (x) => {
      set(() => ({ providerSearchText : x }))
    },
    patientSearchText: {},
    setPatientSearchText: (x) => {
      set(() => ({ patientSearchText : x }))
    },
  clearStore: () => {
    set(() => ({ patientSummaryData: {} }));
    set(() => ({ diagnosisCodeData: [] }));
    set(() => ({ providerSummaryData: [] }));
    set(() => ({ providerSearchText: {} }));
    set(() => ({ patientSearchText: {} }));
  }
})

export const usePatientSummaryStore  = create(store)